import React from 'react'
import PropTypes from 'prop-types'

import theme from 'theme_'

export default function SolarIcon({
  color = theme.colors.beachGrey,
  error = false,
}) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_16640_381630"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_16640_381630)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9996 3.6001C11.7278 3.6001 11.5074 3.82047 11.5074 4.09229V5.17533C11.5074 5.44715 11.7278 5.66751 11.9996 5.66751C12.2714 5.66751 12.4918 5.44715 12.4918 5.17533V4.09229C12.4918 3.82047 12.2714 3.6001 11.9996 3.6001ZM10.195 7.93171C10.195 6.93661 11.0045 6.12703 11.9996 6.12703C12.9947 6.12703 13.8042 6.93661 13.8042 7.93171C13.8042 8.92682 12.9947 9.7364 11.9996 9.7364C11.0046 9.7364 10.195 8.92682 10.195 7.93171ZM7.29057 13.0836C7.10488 13.0836 6.93501 13.1882 6.85127 13.3539L5.38862 16.2497H11.5075V13.0836H7.29057ZM17.1479 13.3539C17.0641 13.1882 16.8943 13.0836 16.7086 13.0836H12.4917V16.2497H18.6105L17.1479 13.3539ZM19.1078 17.234L20.3462 19.686C20.5115 20.0132 20.273 20.4001 19.9069 20.4001H12.4917V17.234H19.1078ZM4.89139 17.234L3.65295 19.686C3.48797 20.0127 3.72563 20.4001 4.09221 20.4001H11.5074V17.234H4.89139ZM11.5074 10.6881C11.5074 10.4163 11.7278 10.1959 11.9996 10.1959C12.2714 10.1959 12.4918 10.4163 12.4918 10.6881V11.7712C12.4918 12.043 12.2714 12.2634 11.9996 12.2634C11.7278 12.2634 11.5074 12.043 11.5074 11.7712V10.6881ZM10.3987 5.63465L9.63293 4.86884C9.44072 4.67662 9.1291 4.67662 8.93685 4.86884C8.74467 5.06102 8.74463 5.37267 8.93685 5.56489L9.70259 6.3307C9.89487 6.52295 10.2065 6.52288 10.3987 6.3307C10.5909 6.13848 10.5909 5.82686 10.3987 5.63465ZM14.2966 9.53281L15.0623 10.2986C15.2545 10.4908 15.2545 10.8025 15.0623 10.9947C14.8702 11.1868 14.5585 11.1869 14.3662 10.9947L13.6005 10.2289C13.4083 10.0366 13.4083 9.72499 13.6005 9.53281C13.7927 9.34059 14.1043 9.34059 14.2966 9.53281ZM9.24341 7.43953H8.16044C7.88862 7.43953 7.66825 7.6599 7.66825 7.93171C7.66825 8.20353 7.88862 8.4239 8.16044 8.4239H9.24341C9.51523 8.4239 9.7356 8.20353 9.7356 7.93171C9.7356 7.6599 9.51523 7.43953 9.24341 7.43953ZM14.7559 7.43953H15.8388C16.1107 7.43953 16.331 7.6599 16.331 7.93171C16.331 8.20353 16.1107 8.4239 15.8388 8.4239H14.7559C14.484 8.4239 14.2637 8.20353 14.2637 7.93171C14.2637 7.6599 14.484 7.43953 14.7559 7.43953ZM10.3987 9.53276C10.2064 9.34055 9.89487 9.34058 9.70259 9.53276L8.93685 10.2986C8.74463 10.4908 8.74467 10.8024 8.93685 10.9946C9.12913 11.1868 9.44068 11.1868 9.63293 10.9946L10.3987 10.2288C10.5909 10.0366 10.5909 9.72494 10.3987 9.53276ZM14.3662 4.86885C14.5585 4.67667 14.8701 4.67667 15.0623 4.86885C15.2545 5.06103 15.2545 5.37269 15.0623 5.5649L14.2966 6.33071C14.1043 6.5229 13.7928 6.52293 13.6005 6.33071C13.4083 6.1385 13.4083 5.82688 13.6005 5.63466L14.3662 4.86885Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.7882 0.677319C18.9272 0.744571 19.0413 0.851724 19.115 0.984129L23.3105 8.5241C23.508 8.87905 23.3707 9.32173 23.004 9.51285C22.894 9.57012 22.7712 9.6001 22.6463 9.6001H14.5551C14.1385 9.6001 13.8008 9.2733 13.8008 8.87016C13.8008 8.75685 13.828 8.64508 13.8804 8.54373L17.7762 1.00375C17.9625 0.643183 18.4156 0.497033 18.7882 0.677319Z"
          fill="white"
          visibility={error ? 'visible' : 'hidden'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.7882 0.677319C18.9272 0.744571 19.0413 0.851724 19.115 0.984129L23.3105 8.5241C23.508 8.87905 23.3707 9.32173 23.004 9.51285C22.894 9.57012 22.7712 9.6001 22.6463 9.6001H14.5551C14.1385 9.6001 13.8008 9.2733 13.8008 8.87016C13.8008 8.75685 13.828 8.64508 13.8804 8.54373L17.7762 1.00375C17.9625 0.643183 18.4156 0.497033 18.7882 0.677319ZM18.9436 3.46676H17.9151V6.8001H18.9436V3.46676ZM18.4294 7.46676C18.0506 7.46676 17.7436 7.76524 17.7436 8.13343C17.7436 8.50162 18.0506 8.8001 18.4294 8.8001C18.8081 8.8001 19.1151 8.50162 19.1151 8.13343C19.1151 7.76524 18.8081 7.46676 18.4294 7.46676Z"
          fill={theme.colors.error}
          visibility={error ? 'visible' : 'hidden'}
        />
      </g>
    </svg>
  )
}

SolarIcon.propTypes = {
  color: PropTypes.string,
  error: PropTypes.bool,
}
